module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "viewContainer"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "审核管理",
      "name": "first"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "黑名单管理",
      "name": "second"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeName == 'first'),
      expression: "activeName=='first'"
    }]
  }, [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "fuji",
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_c('div', {
    staticClass: "goodslist1"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "5px"
    }
  }, [_vm._v("搜索/查询")]), _vm._v(" "), _c('span', {
    staticClass: "divReset",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fnReset($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/Reset.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sanjiao",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-10px"
    }
  })]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }]
  }, [_c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "25%"
    },
    attrs: {
      "label": "商家名称："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请输入商家店铺名称或个人商家手机号码",
      "maxlength": "30"
    },
    model: {
      value: (_vm.orderNumber),
      callback: function($$v) {
        _vm.orderNumber = $$v
      },
      expression: "orderNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "25%"
    },
    attrs: {
      "label": "申请时间："
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "type": "daterange",
      "value-format": "yyyy-MM-dd",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    on: {
      "change": _vm.changetime
    },
    model: {
      value: (_vm.orderTime),
      callback: function($$v) {
        _vm.orderTime = $$v
      },
      expression: "orderTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "select",
    staticStyle: {
      "display": "flex",
      "width": "25%"
    },
    attrs: {
      "label": "审核状态："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.shztid),
      callback: function($$v) {
        _vm.shztid = $$v
      },
      expression: "shztid"
    }
  }, _vm._l((_vm.shztArr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "main_container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.chargebackList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "num",
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "申请商家名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.businessname
          }
        }, [_vm._v(_vm._s(scope.row.businessname))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户姓名",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.name))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户电话",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.phone))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户需求",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.cluetypename))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "需求描述",
      "align": "center",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.remark) ? _c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.remark
          }
        }, [_vm._v(_vm._s(scope.row.remark))]) : _c('span', [_vm._v("-")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "购买周期（天）",
      "align": "center",
      "width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.cyclename))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "申请退款时间",
      "align": "center",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.applytime))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "退款理由",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.reson
          }
        }, [_vm._v(_vm._s(scope.row.reson))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.statusname))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.status == 10),
            expression: "scope.row.status == 10"
          }],
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.shenhe(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit-outline"
        }), _vm._v("审核\r\n              ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin": "10px 0",
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "total": _vm.totalOne,
      "current-page": _vm.pageIndexOne
    },
    on: {
      "current-change": _vm.currentchangeOne
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeName == 'second'),
      expression: "activeName=='second'"
    }]
  }, [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "fuji",
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_c('div', {
    staticClass: "goodslist1"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "5px"
    }
  }, [_vm._v("搜索/查询")]), _vm._v(" "), _c('span', {
    staticClass: "divReset",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fnReset($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/Reset.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sanjiao",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-10px"
    }
  })]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }]
  }, [_c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "商家名称："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请输入商家店铺名称或个人商家手机号码",
      "maxlength": "30"
    },
    model: {
      value: (_vm.qiyeName),
      callback: function($$v) {
        _vm.qiyeName = $$v
      },
      expression: "qiyeName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleyjz
    }
  }, [_vm._v("预警值设置")])], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "main_container"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.blacklist,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商家名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.businessname))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "申请退款次数",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.refundcount))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "同意",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.passcount))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "拒绝",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.nopasscount))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.yichu(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-document-delete"
        }), _vm._v(" 移除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin": "10px 0",
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "total": _vm.totalTwo,
      "current-page": _vm.pageIndexTwo
    },
    on: {
      "current-change": _vm.currentchangeTwo
    }
  })], 1)])]), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "title": "审核",
      "custom-class": "registrationRecord",
      "visible": _vm.isToExamine,
      "size": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.isToExamine = $event
      }
    }
  }, [_c('ul', {
    staticStyle: {
      "line-height": "32px"
    }
  }, [_c('li', [_c('span', [_vm._v("退款原因：")]), _vm._v(_vm._s(_vm.inform.resonid == 4 ? '其它原因' : _vm.inform.reson))]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inform.resonid == 4),
      expression: "inform.resonid==4"
    }]
  }, [_c('span', [_vm._v("退款备注：")]), _vm._v(_vm._s(_vm.inform.reson))]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.infoImgs.length > 0),
      expression: "infoImgs.length>0"
    }]
  }, [_vm._v("资料图片：")]), _vm._v(" "), _vm._l((_vm.infoImgs), function(item, index) {
    return _c('span', {
      key: index
    }, [_c('el-image', {
      staticStyle: {
        "width": "80px",
        "height": "80px",
        "margin": "0 10px 10px 0"
      },
      attrs: {
        "src": item,
        "preview-src-list": _vm.infoImgs,
        "fit": "cover"
      },
      on: {
        "click": _vm.handleClickItem
      }
    })], 1)
  }), _vm._v(" "), _c('li', [_vm._v("通话录音")])], 2), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "margin": "0px"
    },
    attrs: {
      "data": _vm.callrecords,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "通话时间",
      "property": "starttime",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "通话录音",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('audio', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.isexpires == 0 && scope.row.tag),
            expression: "scope.row.isexpires==0&&scope.row.tag"
          }],
          staticStyle: {
            "width": "90%",
            "height": "35px",
            "margin": "5px 0"
          },
          attrs: {
            "src": _vm.api2cs + '/api/virtualnumber/callaudio/' + scope.row.tag + '/' + scope.row.callid + '/' + scope.row.orderid,
            "controls": "controls"
          }
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.isexpires == 1),
            expression: "scope.row.isexpires==1"
          }]
        }, [_vm._v("录音已过期")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.tag == '' || scope.row.tag == 0),
            expression: "scope.row.tag==''||scope.row.tag==0"
          }]
        }, [_vm._v("录音未生成")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "20px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.toApproved(16)
      }
    }
  }, [_vm._v("驳回")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toApproved(14)
      }
    }
  }, [_vm._v("通过")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "预警值设置",
      "visible": _vm.yjzsz,
      "center": true,
      "width": "20%"
    },
    on: {
      "update:visible": function($event) {
        _vm.yjzsz = $event
      }
    }
  }, [_c('el-form', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "label": "退款拒绝次数：",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "placeholder": "请输入",
      "maxlength": "5",
      "onkeyup": "this.value=this.value.replace(/\\D|^0/g,'')"
    },
    model: {
      value: (_vm.yjzinput),
      callback: function($$v) {
        _vm.yjzinput = $$v
      },
      expression: "yjzinput"
    }
  }, [_c('i', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  }, [_vm._v("次")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.yjzsz = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.qdyjz()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("审核管理")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("黑名单管理")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-66606e24!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/platformManagement/cancelOrder.vue
// module id = 1706
// module chunks = 3